import {
    Scene,
    PerspectiveCamera,
    Group,
    Vector3,
} from 'three';
import { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader';
import { ASSETS_PATH } from '@app/react/const/variables';
import { createRenderer } from '@app/react/3d/utils/thumbnail';
import { createLight } from '@app/react/3d/utils/order3d';
import { getMediaMobile } from '@app/react/common/useMedia';

const toRad = (degree: number) => degree * (Math.PI / 180);

const modelDesktopPositions = {
    init: {
        pos: { x: -8, y: -10, z: 6 },
        rot: { x: 0, y: 0, z: toRad(45) },
        rotX: 10,
    },
};

const modelMobilePositions = {
    init: {
        pos: { x: -4.5, y: -13, z: 0 },
        rot: { x: 0, y: 0, z: toRad(72) },
        rotX: 20,
    },
};

const getPosition = () => {
    if (getMediaMobile().matches) {
        return modelMobilePositions;
    }
    return modelDesktopPositions;
};

export const initThreejs = (): void => {
    const canvas = document.getElementById('arrow-canvas') as HTMLCanvasElement;
    if (canvas === null) {
        console.error('[3d] canvas null');
        return;
    }

    const width = canvas.clientWidth;
    const height = canvas.clientHeight;
    console.log('[3d] renderer size:', width, height);

    const scene = new Scene();

    const { hemisphereLight, ambientLight, directionalLights } = createLight();
    [hemisphereLight, ambientLight, ...directionalLights].forEach((l) => scene.add(l));

    const renderer = createRenderer(canvas, width, height, window.devicePixelRatio);
    renderer.shadowMap.enabled = true;

    const camera = new PerspectiveCamera(30, width / height, 1, 2000);
    camera.position.set(0, 0, 30);

    const loader = new FBXLoader();

    let modelRef: Group | null = null;

    loader.load(`${ASSETS_PATH}/models/kinteki.fbx`,
                (model) => {
                    model.name = 'YUMI';
                    console.log('[3d] load model', model);

                    const positions = getPosition();
                    const { pos, rot, rotX } = positions.init;
                    model.position.set(pos.x, pos.y, pos.z);
                    model.rotation.set(rot.x, rot.y, rot.z);
                    model.rotateOnAxis(new Vector3(1, 0, 0), toRad(rotX));
                    scene.add(model);
                    modelRef = model;
                });

    const onWindowResize = (): void => {
        const { innerWidth, innerHeight } = window;
        renderer.setSize(innerWidth, innerHeight);
        camera.aspect = innerWidth / innerHeight;
        camera.updateProjectionMatrix();

        const positions = getPosition();
        const { pos, rot, rotX } = positions.init;
        modelRef?.position.set(pos.x, pos.y, pos.z);
        modelRef?.rotation.set(rot.x, rot.y, rot.z);
        modelRef?.rotateOnAxis(new Vector3(1, 0, 0), toRad(rotX));
    };

    window.addEventListener('resize', onWindowResize);
    window.addEventListener('unload', () => {
        window.removeEventListener('resize', onWindowResize);
    });

    function tick() {
        // FPS 30
        setTimeout(() => {
            requestAnimationFrame(tick);
        }, 1000 / 30);

        renderer.render(scene, camera);
    }

    tick();
};

initThreejs();
